<template>
    <ui-dropdown placement="bottom-start" :menu-class="menuClass" trigger-class="flex-1">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 max-h-64 overflow-y-auto w-full">

                <!-- Empty State. -->
                <div v-if="!query" class="text-gray-500 text-sm">
                    Start typing to search for known fixed costs...
                </div>
                <!-- Results -->
                <div v-else class="space-y-6">
                    <div v-if="fixedCosts.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Fixed Costs</div>
                        <div class="space-y-1">
                            <div
                                v-for="fixedCost in fixedCosts"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="fixedCost.name"
                            >
                                <div class="truncate text-sms ml-3 mr-1 pt-0.5 p-0.5 w-full">
                                    <button
                                        @click="selectFixedCost(fixedCost.description,fixedCost.unit,fixedCost.rate, close)"
                                        class="flex px-1.5 py-0.5 -my-0.5 border border-transparent rounded-lg text-xs w-full text-left font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 hover:text-gray-600"
                                    >
                                        <span class="flex-1">{{
                                                fixedCost.description
                                            }} &#x2022 {{ fixedCost.rate | toCurrency }} per {{ fixedCost.unit }}</span>
                                        <span v-if="fixedCost.priceAgreement" class="ml-5 text-red-300"><span
                                            class="fas fa-star"
                                            style="font-size: 8px"> </span> Supplier Quote</span>
                                        <span v-else-if="fixedCost.usedInEstimate" class="ml-5 text-blue-300"><span
                                            class="fas fa-star" style="font-size: 8px"> </span> Used in Estimate</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-gray-500 text-sm">
                        No matching fixed costs found.
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

export default {
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
        menuClass: {
            type: String,
            default: 'w-full',
        },
        store: Object,
        estimate: Object,
    },
    data() {
        return {
            query: '',
            fixedCosts: [],
        }
    },
    computed: {},
    methods: {
        async searchFixedCosts() {
            if (this.store.loaded) {
                if (!this.store.fixedCostProcessed || (this.store.fixedCostProcessed !== this.estimate.collectionBuildUUID)) {
                    let processedFixedCosts = [];
                    Array.from(this.estimate.collectedItems.fixedCosts, ([name, value]) => value).forEach((i) => {
                        processedFixedCosts.unshift({
                            description: i.description,
                            unit: i.unit,
                            rate: i.rate,
                            usedInEstimate: true
                        })
                    })
                    this.store.supplierQuotes.forEach((sq) => {
                        sq.items.forEach((item) => {
                            if (item.type === 'Fixed Cost') {
                                let fixedCost = processedFixedCosts.find((i) => (
                                    (i.description === item.name) &&
                                    (i.unit === item.unitOfMeasure) &&
                                    (i.rate === item.costPerUnit)
                                ));
                                if (!fixedCost) {
                                    fixedCost = {
                                        description: item.name,
                                        unit: item.unitOfMeasure,
                                        rate: item.costPerUnit,
                                    }
                                    processedFixedCosts.unshift(fixedCost)
                                }
                                fixedCost.priceAgreement = true;
                            }
                        })
                    })
                    this.store.processedFixedCosts = processedFixedCosts
                    this.store.fixedCostsProcessed = this.estimate.collectionBuildUUID;
                }
                this.fixedCosts = this.store.processedFixedCosts.filter(this.matchContact)
                    .sort((a, b) => {
                        let score = 0;
                        return score;
                    }).slice(0, 100);
            }
        },
        matchContact(fixedCost) {
            const query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            let ret = query.every((token) => {
                return (fixedCost.description + fixedCost.unit).toLowerCase().includes(token);
            });
            return ret;
        },
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        setQuery(query) {
            this.query = query
            this.searchFixedCosts();
        },
        selectFixedCost(fixedCostDescription, fixedCostUnit, fixedCostRate, close) {
            this.$emit('selected:fixedCost', {fixedCostDescription, fixedCostUnit, fixedCostRate});
            this.query = fixedCostDescription;
            close();
        },
    },
}
</script>
